GP.views.NoResultsItemView = Backbone.Marionette.ItemView.extend({
    tagName: 'div',
    className: 'no-results show',
    template: function() {
        return js_lang.no_results;
    }
});

GP.views.NoResultsTrialUserItemView = Backbone.Marionette.ItemView.extend({
    tagName: 'div',
    className: 'trial-upgrade-wrap show',
    template: function(serialized_data) {
        return template('no-results-upgrade-trial', serialized_data);
    },
    events: {
        'click #trial-upgrade-action-btn': 'redirect_trial_upgrade'
    },
    redirect_trial_upgrade: function() {
        window.location.href = GP.sdata.my_user.trial_upgrade_url;
    }
});

GP.views.NoResultsPendingUserItemView = Backbone.Marionette.ItemView.extend({
    tagName: 'div',
    className: 'trial-upgrade-wrap show',
    template: function(serialized_data) {
        return template('no-results-upgrade-trial', serialized_data);
    },
    events: {
        'click #trial-upgrade-action-btn': 'redirect_pending_update'
    },
    redirect_pending_update: function() {
        window.location.href = GP.sdata.my_user.pending_update_url;
    }
});
